import axios from "axios";
import { Auth } from "aws-amplify";

export const baseUrl = "https://test.baas.batterypool.com";

const getAccessToken = async () => {
  try {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch {
    return null;
  }
};

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    if (config.skipAuth) return config;

    try {
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch {
      console.log("not signed in — request goes out without a token");
      // downstream API will 401/403 via your authorizer if it requires auth
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // e.g. refresh token, redirect to login, etc.
      console.warn("Unauthorized — token invalid or expired");
      // redirectToLogin();
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
